export const defaultMetaDescription =
  'Architektura wnętrz, projekty i aranżacje Wrocław. Architekt Marta Sergiej, wydział architektury wnętrz wrocławskiej Akademii Sztuk Pięknych.';
